
import { LayoutCrearDoc } from "../../layouts"
import { FormCambiarPassword } from "../components";



export const CambioClave = () => {


    return (

        <LayoutCrearDoc titulo='Cambiar Mi Password' add={false}>
            <FormCambiarPassword />
        </LayoutCrearDoc>
    )
}
